<template>
  <div class="vx-card p-6">
    <div class="vx-row">
      <div class="vx-col w-full mt-2">
        <vs-button icon="icon-plus" icon-pack="feather" type="border">Mời thêm thành viên</vs-button>
      </div>
    </div>

    <div class="rows">
        <div class="vx-row">
        <div class="vx-col w-full mt-2">
              <div class="vx-row" style="">
                <div class="vx-col w-full mt-2" style="max-width:25%">
                  <span class="text-topic">Họ và tên</span>
              </div>

              <div class="vx-col  w-full mt-2" style="max-width:25%">
                  <span class="text-topic">Email</span>
              </div>

              <div class="vx-col  w-full mt-2" style="max-width:25%">
                  <span class="text-topic">Số chủ đề</span>
              </div>

              <div class="vx-col w-full mt-2" style="max-width:25%">
                  <span class="text-topic">Thao tác</span>
              </div>
              </div>
          </div>
      </div>
      </div>

     <div class="row">
        <div class="vx-row">
          <div class="vx-col w-full mt-2">
              <div class="rows-1" v-if="index%2 ==0">
                <div class="vx-row">
                <div class="vx-col w-full mt-2" style="max-width:25%">
                  <span class="">{{dataInfo.fullName}}</span>
                </div>

                <div class="vx-col w-full mt-2" style="max-width:25%">
                  <span class="">{{dataInfo.email}}</span>
                </div>

                <div class="vx-col w-full mt-2" style="max-width:25%">
                  <span class="">{{dataInfo.activeStatus}}</span>
                </div>

              <div class="vx-col w-full mt-2" style="max-width:25%">
                  <feather-icon class="icon" icon="EditIcon" @click="editArticle(item.id)"/>
                  <feather-icon class="icon" icon="TrashIcon" @click="confirmDelete(item.id)"></feather-icon>
              </div>
              </div>
              </div>

              <div class="rows-2" v-else>
                <div class="vx-row">
                <div class="vx-col w-full mt-2" style="max-width:25%">
                  <span class="">asdas</span>
                </div>

                <div class="vx-col w-full mt-2" style="max-width:25%">
                  <span class="">asdas</span>
                </div>

                <div class="vx-col w-full mt-2" style="max-width:25%">
                  <span class="">asdas</span>
                </div>

              <div class="vx-col w-full mt-2" style="max-width:25%">
                  <feather-icon class="icon" icon="EditIcon" @click="editArticle(item.id)"/>
                  <feather-icon class="icon" icon="TrashIcon" @click="confirmDelete(item.id)"></feather-icon>
              </div>
              </div>
              </div>
          </div>
      </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <span>Bạn đã thêm <b>1/1</b> thành viên theo giới hạn của gói dịch vụ</span>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  components:{

  },
  data(){
    return {
      index:0,
      dataInfo:{}
    }
  },
  async created(){
    this.dataInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods:{

  }
}
</script>
<style scoped>
.data-range{
  padding: 0px 10px  0px 10px;
}
.number{
  font-size: 25px;
  font-weight: bold;
  margin-top: 10px;
}
.rows-1{
  border: 1px solid #fff;
  padding : 0px 5px 0px 10px;
  background-color: #fff;
  border-radius: 5px;
}
.rows-2{
  background-color: rgb(221 219 219 / 24%);
  padding : 0px 5px 0px 10px;
  background-color: rgb(221 219 219 / 24%);
  border-radius: 5px;
}
.rows{
  border: 1px solid #ccc;
  padding : 0px 5px 5px 10px;
  background-color: #ccc;
  border-radius: 5px;
  margin-top: 20px;
}
.icon{
  width:18px;
  margin-right: 10px;
}
</style>
